<template>
  <section class="contacts-section">
    <!--   <pre v-if="data.list">{{ data.list.source }}</pre> -->
    <div class="contacts-section__inner">
      <div class="contacts-section__head">
        <app-title
          v-if="contactPage && h1Seo"
          :h1="true"
          :no-icon="true"
        >
          {{ h1Seo }}
        </app-title>
        <app-title
          v-if="contactPage && !h1Seo && data.title"
          :h1="true"
          :no-icon="true"
        >
          {{ data.title.source }}
        </app-title>
        <app-title
          v-if="!contactPage && data.title"
          :no-icon="true"
        >
          {{ data.title.source }}
        </app-title>
        <SocialsList
          v-if="contactPage"
          :secondary="true"
          :socials-list="socialsList"
        />
      </div>

      <div class="contacts-section__map">
        <ContactsSectionPlate
          v-if="data.list"
          :data="data.list.source"
          class="contacts-section__map-plate"
        />
        <yandex-map
          class="yandex-map"
          :scroll-zoom="scrollZoom"
          :coords="coords"
          :zoom="12"
          :options="options"
          :controls="controls"
          :detailed-controls="detailedControls"
        >
          <ul class="yandex-map__marker-list">
            <li
              v-for="item in officeList"
              :key="item.index"
              class="yandex-map__marker-item"
            >
              <ymap-marker
                :coords="item"
                marker-id="123"
                :icon="markerIcon"
                hint-content="Наш офис"
              />
            </li>
          </ul>
        </yandex-map>
      </div>
    </div>
  </section>
</template>

<script>
import SocialsList from "@/components/ui/SocialsList.vue";
import { yandexMap, ymapMarker } from "vue-yandex-maps";
import ContactsSectionPlate from "./ContactsSectionPlate.vue";

export default {
  name: "ContactsSection",

  components: { yandexMap, ymapMarker, SocialsList, ContactsSectionPlate },

  inject: ["h1Seo"],
  props: {
    contactPage: {
      type: Boolean,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    socialsList: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showMap: false,
      coords: [59.950186, 30.317488],
      controls: ["zoomControl"],
      scrollZoom: false,
      options: {
        // scrollZoomSpeed: 0.1,
        // avoidFractionalZoom: true,
        minZoom: 12,
        maxZoom: 18,
      },

      detailedControls: {
        zoomControl: {
          position: {
            right: 40,
            top: 40,
          },
        },
      },

      markerIcon: {
        layout: "default#image",
        imageHref: require("../assets/images/map-marker-kvs.png"),
        imageSize: [62, 57],
        imageOffset: [0, 0],
      },

      // Офисы
      officeList: [[59.984445, 30.353525]],
    };
  },

  mounted() {
    this.showMap = true;
  },
};
</script>

<style lang="scss" scoped>
.contacts-section {
  $that: &;

  &__inner {
    @extend %container;
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 24px;

    @include phone {
      display: block;
    }

    .socials-list {
      @include phone {
        padding-top: 12px;
      }
    }
  }

  &__map {
    position: relative;
    height: 628px;

    @include desktop {
      height: 500px;
    }

    @include laptop {
      height: auto;
      position: static;
      margin: 0 -32px;
    }

    @include phone-s {
      margin: 0 -16px;
    }

    .yandex-map {
      position: absolute;
      width: 100vw;
      height: 628px;
      left: 50%;
      transform: translate(-50%, 0);

      @include desktop {
        height: 500px;
      }

      @include laptop {
        height: 400px;
        position: static;
        transform: translate(0, 0);
        width: 100%;
      }
    }
  }

  &__map-plate {
    max-width: 422px;
    position: absolute;
    z-index: 2;
    top: 40px;
    left: 0;
    background-color: $white;
    padding: 40px;

    @include laptop {
      position: static;
      padding: 20px 32px 28px;
      max-width: 100%;
    }
  }
}
</style>
